<template>
	<div class="min-h-screen flex flex-col">
		<!-- Main Content -->
		<main class="flex-grow">
			<TopNavMenu />
			<router-view></router-view>
			<Footer />
			<BackToTop />
		</main>
	</div>
</template>

<script setup>
import TopNavMenu from "@/components/layout/TopNavMenu.vue";
import Footer from "@/components/layout/Footer.vue";
import BackToTop from "@/components/common/BackToTop.vue";
</script>
